<div class="Rectangle-3-Copy-3">
    <div
        class="pb-btn-toggle"
        *ngFor="let ticket of prebuy_tickets"
        [ngClass]="{
            'Rectangle-3-Copy-3-selected': ticket == value || (ticket == 'Max' && value == max),
            'disabledCss': max < ticket && ticket != 'Max',
        }"
        (click)="setTickets(ticket)">
        {{ ticket }}
    </div>
</div>
